import chance from '@/modules/base/services/chance';
import {PositionEnum} from "@/modules/base/enums";
import {inject, injectable} from "inversify";
import {YouthPlayer} from "@/modules/youth/entity";
import {Region} from "@/modules/base/entity";
import CountryRandomizer from "@/modules/base/services/CountryRandomizer";

@injectable()
export default class YouthPlayerFactory {
  constructor(
    @inject(CountryRandomizer) private countryRandomizer: CountryRandomizer,
  ) {}

  async generate(region: Region, count: number, callback?: (player: YouthPlayer) => void): Promise<YouthPlayer[]> {
    const players = [];

    await region.load('countries');

    console.debug(`generate youth for region: ${region.name}.`);

    for (let i = 1; i <= count; i++) {
      const p = new YouthPlayer();

      p.name = `${chance.first()} ${chance.last()}`;
      p.age = chance.integer({min: 8, max: 21});
      p.skill = chance.integer({min: 1, max: 40});
      p.talent = chance.integer({min: 1, max: 100});
      p.revelation = chance.integer({min: 1, max: 100});
      p.position = chance.randomEnum(PositionEnum);
      p.country = await this.countryRandomizer.one(region);

      p.patience = chance.integer({min: 1, max: 100});
      p.greediness = chance.integer({min: 1, max: 100});
      p.resentfulness = chance.integer({min: 1, max: 100});
      p.baseMonthlyPrice = chance.integer({min: 1000, max: 2000});
      p.baseOncePrice = chance.integer({min: 1000, max: 2000});

      if (callback) {
        callback(p);
      }

      await p.save();
      players.push(p);
    }

    return players;
  }
}
